// Module
var code = "<svg width=\"7\" height=\"14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.75 4.667H0V7h1.75v7h2.917V7H6.79L7 4.667H4.667v-.973c0-.557.112-.777.65-.777H7V0H4.779C2.68 0 1.75.923 1.75 2.692v1.975z\" fill=\"#000\" fill-rule=\"evenodd\"/></svg>";
// Exports
export default code;